<section>

    <div class="p-5 card">
        <form [formGroup]="detailForm" (ngSubmit)="onSubmit()">
            <ul class="flex flex-col gap-2">

                <li>
                    <div class="flex justify-between items-center">
                        <label for="benifits" class="label label-text text-sm font-semibold"
                            [ngClass]="{'req':hasBenefits}">Benifits</label>
                        <input [checked]="hasBenefits" (change)="handleFieldToggle('benefits', $event)" type="checkbox"
                            id="benifits"
                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    @if (hasBenefits) {
                    <textarea
                        [ngClass]="{'error': detailForm.get('benefits')?.invalid && detailForm.get('benefits')?.touched}"
                        class="textarea textarea-bordered w-full bg-white" formControlName="benefits"></textarea>
                    @if (detailForm.get('benefits')?.invalid && detailForm.get('benefits')?.touched) {
                    <span class="text-xs text-red-500">
                        @if (!(detailForm.get('benefits')?.value ?? '').toString().trim()) {
                        Benefits are required
                        }@else if (detailForm.get('benefits')?.hasError('benefitsAllowedChars')) {
                        Benefits must contain valid characters
                        }@else if (detailForm.get('benefits')?.hasError('benefitsMinLength')) {
                        Benefits must be at least 10 characters
                        }@else if (detailForm.get('benefits')?.hasError('benefitsMaxLength')) {
                        Benefits must be at most 1000 characters
                        }@else {
                        Please enter valid benefits or remove the checkbox
                        }
                    </span>
                    }
                    }
                </li>

                <li>
                    <div class="flex justify-between items-center">
                        <label for="useful" class="label label-text text-sm font-semibold"
                            [ngClass]="{'req':hasUsefullFor}">Useful For</label>
                        <input [checked]="hasUsefullFor" (change)="handleFieldToggle('usefull_for', $event)"
                            type="checkbox" id="useful"
                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    @if (hasUsefullFor) {
                    <textarea
                        [ngClass]="{'error': detailForm.get('usefull_for')?.invalid && detailForm.get('usefull_for')?.touched}"
                        class="textarea textarea-bordered w-full bg-white" formControlName="usefull_for"></textarea>
                    @if (detailForm.get('usefull_for')?.invalid && detailForm.get('usefull_for')?.touched) {
                    <span class="text-xs text-red-500">
                        @if (detailForm.get('usefull_for')?.hasError('required')) {
                        Useful For is required
                        }@else if (detailForm.get('usefull_for')?.hasError('usefulForAllowedChars')) {
                        Please use valid characters for useful for
                        }@else if (detailForm.get('usefull_for')?.hasError('usefulForMinLength')) {
                        Please enter at least 2 characters for useful for
                        }@else if (detailForm.get('usefull_for')?.hasError('usefulForMaxLength')) {
                        Please enter at most 200 characters for useful for
                        }@else {
                        Please enter valid useful for or remove the checkbox
                        }
                    </span>
                    }
                    }
                </li>

                <li>
                    <div class="flex justify-between items-center">
                        <label for="features" class="label label-text text-sm font-semibold"
                            [ngClass]="{'req':hasFeatures}">Features</label>
                        <input [checked]="hasFeatures" (change)="handleFieldToggle('features', $event)" type="checkbox"
                            id="features"
                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    @if (hasFeatures) {
                    <textarea
                        [ngClass]="{'error': detailForm.get('features')?.invalid && detailForm.get('features')?.touched}"
                        class="textarea textarea-bordered w-full bg-white" formControlName="features"></textarea>
                    @if (detailForm.get('features')?.invalid && detailForm.get('features')?.touched) {
                    <span class="text-xs text-red-500">
                        @if (detailForm.get('features')?.hasError('required')) {
                        Features is required
                        }@else if (detailForm.get('features')?.hasError('featuresAllowedChars')) {
                        Please use valid characters for features
                        }@else if (detailForm.get('features')?.hasError('featuresMinLength')) {
                        Please enter at least 10 characters for features
                        }@else if (detailForm.get('features')?.hasError('featuresMaxLength')) {
                        Please enter at most 1000 characters for features
                        }@else {
                        Please enter valid features or remove the checkbox
                        }
                    </span>
                    }
                    }


                </li>

                <li class="bg-zinc-100 rounded-lg p-3"
                    [ngClass]="{'error': detailForm.get('validity')?.invalid && detailForm.get('validity')?.touched}">
                    <label class="label label-text text-sm font-semibold p-0">Validity</label>
                    @if (detailForm.get('validity')?.invalid && detailForm.get('validity')?.touched) {
                    <span class="text-xs text-red-500">
                        @if (detailForm.get('validity')?.hasError('pastDate')) {
                        Please select today or a future date
                        }@else if (detailForm.get('validity')?.hasError('invalidDate')) {
                        Please select a valid date
                        }@else {
                        Please enter validity in any one field
                        }
                    </span>
                    }
                    <hr class="my-2">
                    <div class="flex items-center">
                        <div class="flex flex-col w-full">
                            <div class="form-control">
                                <label class="label cursor-pointer flex justify-start gap-3 items-center">
                                    <input type="radio" name="validity" class="radio radio-sm checked:bg-blue-600"
                                        [checked]="validatyIsFixedDate" (change)="validatyIsFixedDate = true" />
                                    <span class="label-text text-sm">Fixed Date</span>
                                </label>
                            </div>
                            <div>
                                <input type="date" class="input input-bordered border input-sm bg-white w-full"
                                    [value]="detailForm.get('validity')?.value" (change)="setValidaty($event,'date')"
                                    [min]="todayDate" [disabled]="!validatyIsFixedDate">
                            </div>
                        </div>
                        <div class="divider divider-horizontal text-xs font-semibold text-zinc-400">OR</div>
                        <div class="flex flex-col w-full">
                            <div class="form-control">
                                <label class="label cursor-pointer flex justify-start gap-3 items-center">
                                    <input type="radio" name="validity" class="radio radio-sm checked:bg-blue-600"
                                        [checked]="!validatyIsFixedDate" (change)="validatyIsFixedDate = false" />
                                    <span class="label-text">No of Days</span>
                                </label>
                            </div>
                            <div>
                                <input type="number" class="input input-bordered border input-sm bg-white w-full"
                                    placeholder=" No of Days" (change)="setValidaty($event,'days')"
                                    [value]="validityDaysInput ?? ''" min="1" [disabled]="validatyIsFixedDate" />
                            </div>
                        </div>
                    </div>

                </li>

                <li class="bg-zinc-100 rounded-lg p-3" formGroupName="price_detail">
                    <label class="label label-text text-sm font-semibold">Pricing</label>
                    <hr class="my-2">

                    @if (courseType?.type === 'video' || courseType?.type === 'flashcard') {

                    <div class="flex justify-between items-center mb-3">
                        <label class="label label-text text-sm font-semibold p-0">Customization Available for
                            Students</label>
                        <input type="checkbox" [checked]="isPrizeCustimizable" (change)="setIsPrizeCustimizable($event)"
                            id="isPrizeCustimizable"
                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    }

                    <ul class="grid grid-cols-1 gap-2">
                        <li class="flex justify-between items-center">
                            <label class="text-sm">Price for completeing course</label>
                            <div>

                                <label class="input input-bordered input-sm flex items-center gap-2"
                                    [ngClass]="{'error': detailForm.get('price_detail')?.get('price')?.invalid && detailForm.get('price_detail')?.get('price')?.touched}">
                                    ₹
                                    <input type="number" min="0" class="" placeholder="" formControlName="price"
                                        (input)="calculateGrossTotal()" appNonNegative />
                                </label>
                                @if (detailForm.get('price_detail')?.get('price')?.invalid &&
                                detailForm.get('price_detail')?.get('price')?.touched) {
                                <span class="text-xs text-red-500">
                                    @if (detailForm.get('price_detail')?.get('price')?.hasError('required')) {
                                    Price is required
                                    } @else if (detailForm.get('price_detail')?.get('price')?.hasError('priceInvalid')) {
                                    Price must be a valid non-negative number
                                    } @else if (detailForm.get('price_detail')?.get('price')?.hasError('priceMaxLength')) {
                                    Price cannot exceed 7 digits
                                    } @else {
                                    Please enter a valid price
                                    }
                                </span>
                                }
                            </div>
                        </li>

                       @if (courseType?.type === 'flashcard' && isPrizeCustimizable) {
<li class="flex justify-between items-start">
    <label class="text-sm pt-2">Price per flashcard</label>

    <div>
        <label
            class="input input-bordered input-sm flex items-center gap-2"
            [ngClass]="{
              'error':
                detailForm.get('price_detail')?.get('price_per_flashcard')?.invalid &&
                detailForm.get('price_detail')?.get('price_per_flashcard')?.touched
            }"
        >
            ₹
            <input
                type="number"
                class="w-full"
                formControlName="price_per_flashcard"
                appNonNegative
            />
        </label>

        @if (
          detailForm.get('price_detail')?.get('price_per_flashcard')?.invalid &&
          detailForm.get('price_detail')?.get('price_per_flashcard')?.touched
        ) {
        <span class="text-xs text-red-500 mt-1 block">
            @if (detailForm.get('price_detail')?.get('price_per_flashcard')?.hasError('required')) {
                Price per flashcard is required.
            } @else if (detailForm.get('price_detail')?.get('price_per_flashcard')?.hasError('pricePerFlashcardInvalid')) {
                Price must be a valid non-negative number.
            } @else if (detailForm.get('price_detail')?.get('price_per_flashcard')?.hasError('pricePerFlashcardMaxLength')) {
                Price cannot exceed 7 digits.
            } @else {
                Please enter a valid price.
            }
        </span>
        }
    </div>
</li>
}
                        @if(courseType?.type === 'video' && isPrizeCustimizable) {
                        <li>
                            <div>
                                <table class="table table-auto w-full border overflow-hidden rounded-lg bg-white">
                                    <thead class="">
                                        <tr>
                                            <th class=" font-semibold border p-2">Chapter</th>
                                            <th class=" font-semibold border p-2">Price (₹)</th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="custmization_price_detail">
                                        @for (group of custmizationPriceDetails.controls; track $index) {
                                        <tr [formGroupName]="$index">
                                            <td class="w-full p-2 border text-sm capitalize">
                                                {{ group.get('structure_name')?.value }}
                                            </td>
                                            <td class="p-2 border">
                                                <label class="input input-ghost input-sm w-32 flex items-center gap-2">
                                                    ₹
                                                    <input type="number" [value]="group.get('price')?.value"
                                                        class="w-full" formControlName="price"
                                                        placeholder="Enter price" (input)="onCustomizationPriceChange()" appNonNegative/>
                                                </label>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        }

                        <li>
                            <hr>
                        </li>
                        <li class="grid-cols-3 grid  gap-2 divide-x">

                            <div class="">
                                <label class="text-sm">Gross Total</label>
                                <label class="input input-bordered input-sm flex items-center gap-2 mt-1"
                                    [ngClass]="{'error': detailForm.get('price_detail')?.get('price')?.hasError('priceMaxLength')}">
                                    ₹
                                    <input type="number" class="" placeholder="" formControlName="gross_total"
                                        readonly appNonNegative/>
                                </label>
                                @if (detailForm.get('price_detail')?.get('price')?.hasError('priceMaxLength')) {
                                <span class="text-xs text-red-500">Net amount cannot exceed 7 digits</span>
                                }
                            </div>

                            <div class="pl-2">
                                <label class="text-sm">Discount Type</label>
                                <div class="flex items-center  gap-2 mt-1">
                                    <div>
                                        <input class="hidden custom-toggle" type="radio" id="net"
                                            (change)="calculateFinalPrice()" value="$"
                                            [checked]="detailForm.get('price_detail')?.get('discount_type')?.value == '$'"
                                            formControlName="discount_type" />
                                        <label for="net" class="w-full">Net</label>
                                    </div>
                                    <div>
                                        <input class="hidden custom-toggle" type="radio"
                                            (change)="calculateFinalPrice()" id="Persentage" value="%"
                                            [checked]="detailForm.get('price_detail')?.get('discount_type')?.value == '%'"
                                            formControlName="discount_type" />
                                        <label for="Persentage" class="w-full">Persentage</label>
                                    </div>
                                </div>
                            </div>

                            <div class="pl-2">
                                <label class="text-sm">Gross Discount</label>
                                <label class="input input-bordered input-sm flex items-center gap-2 mt-1"
                                    [ngClass]="{'error': detailForm.get('price_detail')?.get('gross_discount')?.invalid && detailForm.get('price_detail')?.get('gross_discount')?.touched}">
                                    {{detailForm.get('price_detail')?.get('discount_type')?.value == '$' ? '₹' : '%'}}
                                    <input type="number" class="" placeholder="" formControlName="gross_discount"
                                        (change)="calculateFinalPrice()" appNonNegative/>
                                </label>
                                @if (detailForm.get('price_detail')?.get('gross_discount')?.invalid &&
                                detailForm.get('price_detail')?.get('gross_discount')?.touched) {
                                <span class="text-xs text-red-500">
                                    @if (detailForm.get('price_detail')?.get('gross_discount')?.hasError('grossDiscountInvalid')) {
                                    Discount must be a valid non-negative number
                                    }@else if (detailForm.get('price_detail')?.get('gross_discount')?.hasError('grossDiscountMaxLength')) {
                                    Discount cannot exceed 7 digits
                                    }@else {
                                    Please enter a valid discount
                                    }
                                </span>
                                }

                            </div>


                        </li>
                        <li>
                            <hr>
                            <!-- @if (appliedCoupons.length) {
                            <div class="flex flex-col gap-2 py-2 text-sm">
                                <span class="font-medium">Selected Coupons</span>
                                @for (coupon of appliedCoupons; track $index) {
                                <div class="flex justify-between">
                                    <span>{{ coupon.title || coupon.code }}</span>
                                    <span class="font-semibold text-red-600">
                                        {{ coupon.discount_amount }}{{ coupon.discount_type === '$' ? '.Rs' : '%' }}
                                    </span>
                                </div>
                                }
                            </div>
                            <hr>
                            } -->
                            <div class="flex justify-between items-center py-2">
                                <div>
                                    <span class="font-medium text-sm">Net Price Full</span>
                                   
                                </div>
                                <span class="text-lg font-semibold">₹ {{finalPrice}}</span>
                            </div>
                            <hr>
                        </li>

                        <li class="flex justify-between items-center">
                            <label class="text-sm">Additional Discount </label>
                            <button type="button" class="btn btn-xs bg-white border text-red-600"
                                (click)="openCouponModal()">
                                <i class="ri-coupon-2-fill"></i>
                                Add Coupon</button>
                        </li>
                        <li class="bg-white border p-3 rounded-lg">
                            <p class="font-semibold text-red-600 text-sm">Admin Only</p>
                            <hr class="my-2">
                            <div class="form-control">

                                <div class="overflow-x-auto">
                                    <table class="table">
                                        <!-- head -->
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Titel</th>
                                                <th>Discount</th>
                                                <th>Code</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (i of couponsList; track $index) {

                                            <tr>
                                                <th>
                                                    <input type="checkbox"
                                                        class="checkbox checkbox-sm"
                                                        [checked]="isCouponSelected(i.id)"
                                                        (change)="onCouponSelectionChange(i.id, $event)">

                                                </th>
                                                <td>{{i.title}}</td>
                                                <td>{{i.discount_amount}}{{i.discount_type == '$' ? '₹' : '%'}} OFF</td>
                                                <td class="font-semibold">{{i.code}}</td>
                                                <td class="flex items-center gap-2">
                                                    <button type="button" class="btn btn-sm btn-square text-zinc-500"
                                                        (click)="viewCouponImage(i)"><i
                                                            class="ri-eye-fill"></i></button>
                                                    <button type="button"
                                                        class="btn btn-sm btn-square bg-red-50 text-red-600"
                                                        (click)="deleteCoupon(i.id)"><i
                                                            class="ri-delete-bin-2-fill"></i></button>
                                                </td>
                                            </tr>
                                            }

                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </li>
                    </ul>
                </li>

                <li>
                    <div class="flex justify-between items-center">
                        <label for="howToUse" class="label label-text text-sm font-semibold"
                            [ngClass]="{'req':hasHowToUse}">How to use</label>
                        <input [checked]="hasHowToUse" (change)="handleFieldToggle('how_to_use', $event)"
                            type="checkbox" id="howToUse"
                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    @if (hasHowToUse) {
                    <textarea
                        [ngClass]="{'error': detailForm.get('how_to_use')?.invalid && detailForm.get('how_to_use')?.touched}"
                        class="textarea textarea-bordered w-full bg-white" formControlName="how_to_use"></textarea>
                    @if (detailForm.get('how_to_use')?.invalid && detailForm.get('how_to_use')?.touched) {
                    <span class="text-xs text-red-500">
                        @if (detailForm.get('how_to_use')?.hasError('required')) {
                        How to use is required
                        }@else if (detailForm.get('how_to_use')?.hasError('howToUseAllowedChars')) {
                        Please enter valid instructions.
                        }@else if (detailForm.get('how_to_use')?.hasError('howToUseMinLength')) {
                        Please enter at least 10 characters for how to use
                        }@else if (detailForm.get('how_to_use')?.hasError('howToUseMaxLength')) {
                        Please enter at most 3000 characters for how to use
                        }@else {
                        Please enter valid how to use or remove the checkbox
                        }
                    </span>
                    }
                    }
                </li>

                <li>
                    <ul formArrayName="youtube_link" class="flex flex-col gap-2">
                        @for (link of youtubeLinks.controls; track $index) {
                        <li>
                            <div class="flex gap-3 items-center">
                                <input type="text" class="input input-sm input-bordered w-full bg-white"
                                    [ngClass]="{'error': detailForm.get(['youtube_link', $index])?.invalid && detailForm.get(['youtube_link', $index])?.touched}"
                                    [value]="link.value" [formControlName]="$index" placeholder="Add YouTube Link" />

                                <button type="button" class="btn btn-square btn-sm border text-red-600"
                                    (click)="addRemoveYoutubeLink('remove', $index)">
                                    <i class="ri-delete-bin-line"></i>
                                </button>
                            </div>
                            @if (detailForm.get(['youtube_link', $index])?.touched &&
                            detailForm.get(['youtube_link', $index])?.hasError('required')) {
                            <span class="text-xs text-red-500">Please enter a YouTube link</span>
                            }

                            @if (detailForm.get(['youtube_link', $index])?.touched &&
                            detailForm.get(['youtube_link', $index])?.hasError('pattern')) {
                            <span class="text-xs text-red-500">Please enter a valid YouTube link</span>
                            }
                        </li>
                        }
                    </ul>

                    <button type="button" class="btn btn-sm mt-3 btn-error bg-red-600 text-white font-normal"
                        (click)="addRemoveYoutubeLink('add')">
                        <i class="ri-youtube-fill"></i> Add YouTube Link
                    </button>
                </li>



                <li>
                    <div class="flex justify-between items-center">
                        <label for="others" class="label label-text text-sm font-semibold"
                            [ngClass]="{'req':hasOthers}">Others</label>
                        <input [checked]="hasOthers" (change)="handleFieldToggle('others', $event)" type="checkbox"
                            id="others"
                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    @if (hasOthers) {
                    <textarea
                        [ngClass]="{'error': detailForm.get('others')?.invalid && detailForm.get('others')?.touched}"
                        class="textarea textarea-bordered w-full bg-white" formControlName="others"></textarea>
                    @if (detailForm.get('others')?.invalid && detailForm.get('others')?.touched) {
                    <span class="text-xs text-red-500">
                        @if (detailForm.get('others')?.hasError('othersAllowedChars')) {
                        Please use valid characters for others
                        }@else if (detailForm.get('others')?.hasError('othersMaxLength')) {
                        Please enter at most 1000 characters for others
                        }@else {
                        Others is required
                        }
                    </span>
                    }
                    }
                </li>

                <li>
                    <div class="flex justify-between items-center">
                        <label for="termsandcondition" class="label label-text text-sm font-semibold"
                            [ngClass]="{'req':hasTermsCondition}">Terms &
                            Condition</label>
                        <input [checked]="hasTermsCondition" (change)="handleFieldToggle('terms_condition', $event)"
                            type="checkbox" id="termsandcondition"
                            class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                    </div>
                    @if (hasTermsCondition) {
                    <textarea
                        [ngClass]="{'error': detailForm.get('terms_condition')?.invalid && detailForm.get('terms_condition')?.touched}"
                        class="textarea textarea-bordered w-full bg-white" formControlName="terms_condition"></textarea>
                    @if (detailForm.get('terms_condition')?.invalid && detailForm.get('terms_condition')?.touched) {
                    <span class="text-xs text-red-500">
                        @if (detailForm.get('terms_condition')?.hasError('required')) {
                        Terms & Condition is required
                        }@else if (detailForm.get('terms_condition')?.hasError('termsAllowedChars')) {
                        Please use valid characters for terms & condition
                        }@else if (detailForm.get('terms_condition')?.hasError('termsMinLength')) {
                        Please enter at least 20 characters for terms & condition
                        }@else if (detailForm.get('terms_condition')?.hasError('termsMaxLength')) {
                        Please enter at most 5000 characters for terms & condition
                        }@else {
                        Please enter valid terms & condition or remove the checkbox
                        }
                    </span>
                    }
                    }
                </li>
            </ul>

            <div class="flex justify-end gap-3 ">
                <!-- <button type="button" class="btn btn-sm capitalize btn-outline">save & preview</button> -->
                <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                    @if (isreqSending) {
                    <i class="ri-loader-2-line animate-spin"></i>
                    }@else {
                    <span>Save</span>
                    }
                </button>
            </div>

        </form>
    </div>


</section>



<!-- create discount coupon -->
<dialog #discountCouponModal id="discount_coupon_modal" class="modal">
    <div class="modal-box min-w-sm max-w-3xl">

        <div class="flex justify-between items-center font-semibold">
            <p>Create Discount Coupon</p>
            <form method="dialog">
                <button #closeModel class="btn btn-circle btn-sm btn-light flex justify-center items-center"><i
                        class="ri-close-line"></i>
                </button>
            </form>
        </div>
        <hr class="mt-4 mb-1">
        <form [formGroup]="couponForm">
            <div class=" grid grid-cols-2  mt-3">

                <div class="col-span-1 grid grid-cols-2 gap-3 ">

                    <div class="col-span-2">
                        <label class="form-control w-full">
                            <span class="label-text text-sm mb-1">Title <span class="text-red-500">*</span></span>
                            <input formControlName="title" type="text" placeholder="Summer Sale"
                                class="input input-bordered input-sm  w-full " />
                            @if (couponForm.get('title')?.invalid && couponForm.get('title')?.touched) {
                            <span class="text-xs text-red-500">
                                @if (couponForm.get('title')?.hasError('required')) {
                                Title is required
                                } @else if (couponForm.get('title')?.hasError('couponTitleRequired')) {
                                Title cannot be only spaces
                                } @else if (couponForm.get('title')?.hasError('couponTitleTrim')) {
                                Please remove leading/trailing spaces
                                } @else if (couponForm.get('title')?.hasError('couponTitleMinLength')) {
                                Coupon title must be at least 2 characters
                                } @else if (couponForm.get('title')?.hasError('couponTitleMaxLength')) {
                                Coupon title must be at most 100 characters
                                } @else if (couponForm.get('title')?.hasError('couponTitleAllowedChars')) {
                                Please enter a valid coupon title
                                } @else {
                                Invalid coupon title
                                }
                            </span>
                            }
                        </label>
                    </div>
                    <div class="col-span-2">
                        <label class="form-control w-full">
                            <span class="label-text text-sm mb-1">Coupon Code <span class="text-red-500">*</span></span>
                            <input type="text" formControlName="code" placeholder="SAVE20"
                                class="input input-bordered input-sm   w-full " />
                            @if (couponForm.get('code')?.invalid && couponForm.get('code')?.touched) {
                            <span class="text-xs text-red-500">
                                @if (couponForm.get('code')?.hasError('required')) {
                                Coupon code is required
                                } @else if (couponForm.get('code')?.hasError('couponCodeSpacesNotAllowed')) {
                                Coupon code cannot contain spaces
                                } @else if (couponForm.get('code')?.hasError('couponCodeTrim')) {
                                Please remove leading/trailing spaces
                                } @else if (couponForm.get('code')?.hasError('couponCodeMinLength')) {
                                Coupon code must be at least 3 characters
                                } @else if (couponForm.get('code')?.hasError('couponCodeMaxLength')) {
                                Coupon code must be at most 20 characters
                                } @else if (couponForm.get('code')?.hasError('couponCodeAllowedChars')) {
                                Only letters and numbers are allowed
                                } @else {
                                Invalid coupon code
                                }
                            </span>
                            }
                        </label>
                    </div>

                    <div class="col-span-2 grid-cols-2 grid gap-3 p-3 bg-zinc-100 rounded-lg">
                        <div class="col-span-1">
                            <label class="form-control w-full">
                                <span class="label-text text-sm mb-1">Discount Type <span class="text-red-500">*</span></span>
                                <select formControlName="discount_type"
                                    class="select select-sm select-bordered w-full ">
                                    <option value="$">Net Amount</option>
                                    <option value="%">Percentage</option>
                                </select>
                                @if (couponForm.get('discount_type')?.invalid && couponForm.get('discount_type')?.touched) {
                                <span class="text-xs text-red-500">Discount type is required</span>
                                }
                            </label>
                        </div>
                        <div class="col-span-1">
                            <label class="form-control w-full">
                                <span class="label-text text-sm mb-1">Discount Amount <span class="text-red-500">*</span></span>
                                <input formControlName="discount_amount" type="text" placeholder=""
                                    class="input input-bordered input-sm  w-full " />
                                @if (couponForm.get('discount_amount')?.invalid && couponForm.get('discount_amount')?.touched) {
                                <span class="text-xs text-red-500">
                                    @if (couponForm.get('discount_amount')?.hasError('required')) {
                                    Discount amount is required
                                    } @else if (couponForm.get('discount_amount')?.hasError('pattern')) {
                                    Discount amount must be digits only
                                    } @else if (couponForm.get('discount_amount')?.hasError('couponDiscountDigitsOnly')) {
                                    Discount amount must be digits only
                                    } @else if (couponForm.get('discount_amount')?.hasError('couponDiscountMinValue')) {
                                    Discount amount must be greater than 0
                                    } @else if (couponForm.get('discount_amount')?.hasError('couponDiscountPercentageMax')) {
                                    Percentage discount cannot exceed 100%
                                    } @else if (couponForm.get('discount_amount')?.hasError('couponDiscountExceedsCoursePrice')) {
                                    Discount cannot exceed the course price
                                    } @else if (couponForm.get('discount_amount')?.hasError('couponDiscountMaxLength')) {
                                    Discount amount cannot exceed 7 digits
                                    } @else {
                                    Invalid discount amount
                                    }
                                </span>
                                }
                            </label>
                        </div>
                    </div>

                    <div class="col-span-2 grid-cols-2 grid gap-3 p-3 bg-zinc-100 rounded-lg">

                        <div class="col-span-1">
                            <label class="form-control w-full">
                                <span class="label-text text-sm mb-1">From Date <span class="text-red-500">*</span></span>
                                <input formControlName="from_date" type="date" placeholder=""
                                    class="input input-bordered input-sm  w-full " />
                                @if (couponForm.get('from_date')?.invalid && couponForm.get('from_date')?.touched) {
                                <span class="text-xs text-red-500">
                                    @if (couponForm.get('from_date')?.hasError('required')) {
                                    From date is required
                                    } @else if (couponForm.get('from_date')?.hasError('couponExpiryInvalidDate')) {
                                    Please select a valid start date
                                    } @else if (couponForm.get('from_date')?.hasError('couponExpiryPastDate')) {
                                    Past dates are not allowed
                                    } @else {
                                    Invalid start date
                                    }
                                </span>
                                }
                            </label>

                        </div>
                        <div class="col-span-1">
                            <label class="form-control w-full">
                                <span class="label-text text-sm mb-1">To Date <span class="text-red-500">*</span></span>
                                <input formControlName="to_date" type="date" placeholder=""
                                    class="input input-bordered input-sm  w-full " />
                                @if (couponForm.get('to_date')?.invalid && couponForm.get('to_date')?.touched) {
                                <span class="text-xs text-red-500">
                                    @if (couponForm.get('to_date')?.hasError('required')) {
                                    To date is required
                                    } @else if (couponForm.get('to_date')?.hasError('couponExpiryInvalidDate')) {
                                    Please select a valid expiry date
                                    } @else if (couponForm.get('to_date')?.hasError('couponExpiryPastDate')) {
                                    Past dates are not allowed
                                    } @else if (couponForm.get('to_date')?.hasError('couponToBeforeFromDate')) {
                                    To date must be on or after from date
                                    } @else {
                                    Invalid expiry date
                                    }
                                </span>
                                }

                            </label>
                        </div>
                    </div>
                    <div class="col-span-2">
                        <label class="form-control w-full">
                            <span class="label-text text-sm mb-1">Usage Per User <span class="text-red-500">*</span></span>
                            <input formControlName="usage_per_user" type="number" min="1" placeholder="1"
                                class="input input-bordered input-sm w-full" />
                            @if (couponForm.get('usage_per_user')?.invalid && couponForm.get('usage_per_user')?.touched) {
                            <span class="text-xs text-red-500">
                                @if (couponForm.get('usage_per_user')?.hasError('required')) {
                                Usage per user is required
                                } @else if (couponForm.get('usage_per_user')?.hasError('pattern') || couponForm.get('usage_per_user')?.hasError('couponUsageDigitsOnly')) {
                                Usage per user must be digits only
                                } @else if (couponForm.get('usage_per_user')?.hasError('couponUsageMinValue')) {
                                Usage per user must be greater than 0
                                } @else if (couponForm.get('usage_per_user')?.hasError('couponUsageMaxValue')) {
                                Usage per user cannot exceed the maximum allowed limit
                                } @else {
                                Invalid usage per user
                                }
                            </span>
                            }
                        </label>
                    </div>

                </div>

                <div class="col-span-1  pl-4">

                    @if (!customCouponImageUrl) {
                    <!-- coupon card -->
                    <div class="w-full p-1 rounded-lg border-2 border-dashed">

                        <!-- card -->
                        <div #couponCard id="coupon-card" class="w-full aspect-[16/7] rounded-xl relative group"
                            [ngClass]="'bg-gradient-to-r from-' + bgFromColor + ' to-' + bgToColor">

                            <button (click)="downloadCardAsImage('coupon-card')"
                                class="no-export opacity-0 transition-all duration-150 group-hover:opacity-100 w-8 h-8 ring-4 ring-white/50  rounded-full text-balck bg-white backdrop-blur absolute top-3 right-3"><i
                                    class="ri-download-line"></i></button>

                            <div class="w-full grid grid-cols-5 h-full">

                                <div class="col-span-2 flex flex-col justify-center items-center h-full">
                                    <div class="w-3/4 aspect-square bg-white/50 p-2 mask {{activeMaskShape}} relative">

                                        @if (couponImageUrl) {
                                        <img [src]="couponImageUrl" alt="" (error)="onImageError($event)"
                                            class="absolute top-0 left-0 w-full h-full object-cover">
                                        }@else{
                                        <div
                                            class="flex flex-col text-white justify-center items-center text-center h-full leading-3">
                                            <i class="ri-image-circle-ai-line text-3xl font-extralight"></i>
                                            <p class="text-sm font-medium">Upload</p>
                                        </div>
                                        }
                                         <!-- // this is on coupen  -->
                                        <input type="file" class="absolute top-0 left-0 w-full h-full opacity-0"
                                            accept="image/*" (change)="onFileSelected($event)">



                                    </div>
                                    <!-- <p class="text-xs font-semibold text-white/70 mt-2"></p> -->
                                </div>
                                <div class="p-3 col-span-3 leading-3 text-center">
                                    <small class="text-xs text-white/50">Benifits given by Amit Laddha</small>
                                    <h2 class="text-2xl font-semibold text-white my-1">{{
                                        couponForm.get('discount_amount')?.value || '0'}}{{
                                        couponForm.get('discount_type')?.value == '$' ? '₹' : '%'}} OFF</h2>
                                    <p class="text-white">{{ couponForm.get('title')?.value || 'Title Here' }}</p>
                                    <div
                                        class="bg-white/20 p-1 rounded-lg mt-4 text-white border-2 border-dashed text-xl font-bold">
                                        <span class="uppercase">{{ couponForm.get('code')?.value || 'CODE HERE'}}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- card -->

                        <div class="flex gap-3 mt-3">
                            <!-- shape -->
                            <div>
                                <select formControlName="image_shape"
                                    class="select select-sm select-bordered w-full max-w-xs"
                                    (change)="onMaskShapeChange($event)">
                                    <option disabled selected>Image Shape</option>
                                    @for (i of maskShapes; track $index) {
                                    <option [value]="i.class">{{i.shape}}</option>
                                    }
                                </select>
                            </div>
                            <!-- shape -->
                            <!-- bg color -->
                            <div class="join">
                                <span
                                    class="btn btn-sm btn-disabled join-item text-xs !text-zinc-500 font-medium !bg-zinc-100">Background</span>
                                <div class="dropdown dropdown-bottom dropdown-end join-item">
                                    <div tabindex="0" role="button" data-tip="Background Start Color"
                                        class="btn btn-sm join-item flex items-center gap-2 font-medium tooltip tooltip-left">
                                        <span class="flex w-4 h-4 rounded-md" [ngClass]="'bg-' + bgFromColor"></span>
                                    </div>
                                    <ul tabindex="0"
                                        class="dropdown-content menu bg-base-100 rounded-box z-[1] w-[30rem] p-2 shadow text-sm flex flex-col gap-2 max-h-60 overflow-y-auto">

                                        @for (i of shades; track $index) {
                                        <div class="p-2 bg-zinc-100 rounded-xl capitalize">
                                            <p class="text-xs font-semibold text-zinc-500">{{ i.color }}</p>
                                            <div class="flex gap-2 items-center mt-1 flex-wrap">
                                                @for (shade of i.shades; track $index) {
                                                <button class="tooltip" [attr.data-tip]="shade"
                                                    (click)="setBackgroundStartColor(shade)" [ngClass]="{
                                                        'rounded-full ring-2 ring-offset-2': bgToColor === shade || bgFromColor === shade,
                                                        'ring-black': bgFromColor === shade,
                                                        'ring-black/30': bgToColor === shade && bgFromColor !== shade
                                                      }">
                                                    <span class="flex w-4 h-4 rounded-full"
                                                        [ngClass]="'bg-' + shade"></span>
                                                </button>
                                                }
                                            </div>
                                        </div>
                                        }



                                    </ul>
                                </div>
                                <div class="dropdown dropdown-bottom dropdown-end">
                                    <div tabindex="0" role="button" data-tip="Background End Color"
                                        class="btn btn-sm join-item flex items-center gap-2 font-medium tooltip  tooltip-left">
                                        <span class="flex w-4 h-4 rounded-md" [ngClass]="'bg-' + bgToColor"></span>
                                    </div>
                                    <ul tabindex="0"
                                        class="dropdown-content menu bg-base-100 rounded-box z-[1] w-[30rem] p-2 shadow text-sm flex flex-col gap-2 max-h-60 overflow-y-auto">

                                        @for (i of shades; track $index) {
                                        <div class="p-2 bg-zinc-100 rounded-xl capitalize">
                                            <p class="text-xs font-semibold text-zinc-500">{{ i.color }}</p>
                                            <div class="flex gap-2 items-center mt-1 flex-wrap">
                                                @for (shade of i.shades; track $index) {
                                                <button class="tooltip" [attr.data-tip]="shade"
                                                    (click)="setBackgroundEndColor(shade)" [ngClass]="{
                                                        'rounded-full ring-2 ring-offset-2': bgToColor === shade || bgFromColor === shade,
                                                        'ring-black': bgToColor === shade,
                                                        'ring-black/30': bgFromColor === shade && bgToColor !== shade
                                                      }">
                                                    <span class="flex w-4 h-4 rounded-full"
                                                        [ngClass]="'bg-' + shade"></span>
                                                </button>
                                                }
                                            </div>
                                        </div>
                                        }



                                    </ul>
                                </div>
                            </div>
                            <!-- bg color -->
                            <!--  -->
                        </div>

                    </div>
                    <!-- coupon card -->

                    <div class="divider text-xs font-semibold text-zinc-500">OR</div>
                    }

                    <!-- upload custome upload -->
                    <div class="col-span-1">
                        <div
                            class=" w-full aspect-[16/7] border-2 border-zinc-300 border-dashed rounded-md flex justify-center items-center relative group hover:border-zinc-500 overflow-hidden">



                            @if (customCouponImageUrl) {
                            <div>
                                <img class="w-full h-full object-cover" src="{{customCouponImageUrl}}" alt="">
                                <div
                                    class="flex items-center justify-center gap-2 text-white bg-black/50 backdrop-blur-sm absolute top-0 left-0 w-full h-full opacity-0 transition duration-300 group-hover:opacity-100">
                                    <i class="ri-image-edit-fill text-3xl "></i>
                                    <p class="text-sm  border-l border-white pl-2 font-medium">Change Coupon Image</p>
                                </div>
                            </div>
                            }@else {
                            <div class="flex items-center gap-2 text-zinc-400">
                                <i class="ri-image-fill text-3xl group-hover:text-zinc-500"></i>
                                <p class="text-sm  border-l border-zinc-300 pl-2 font-medium">Upload Coupon Image</p>
                            </div>
                            }

                            <input type="file" (change)="addCouponImage($event)"
                                class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" accept="image/*"
                                name="" id="">

                        </div>

                    </div>
                    <!-- upload custome upload -->
                    @if (customCouponImageUrl) {
                    <button
                        class="mt-3 btn btn-sm capitalize bg-white hover:bg-zinc-100 border text-red-600 font-medium"
                        (click)="removeCouponImage()"><i class="ri-delete-bin-fill"></i> Remove Coupon Image</button>
                    }

                    <div class="mt-3 text-xs text-red-500">
                        @if (!customCouponImageUrl && !couponImageUrl) {
                        <p>Either coupon card image or uploaded coupon image is required</p>
                        }
                    </div>





                </div>



            </div>

        </form>

            <hr class="my-3">
            <div class="flex justify-end gap-3 mt-3">
                <button type="button" class="btn btn-sm capitalize" (click)="closeCouponModal()">Cancel</button>
                <button
                    type="button"
                    class="btn btn-sm capitalize btn-primary"
                    (click)="saveCoupon($event)"
                    [disabled]="savingCoupon"
                >
                    {{ savingCoupon ? 'Saving...' : 'Save' }}
                </button>
            </div>



    </div>
</dialog>
<!-- create discount coupon -->


<!-- view coupon image -->
<dialog #viewCouponModal class="modal">
    <div class="modal-box max-w-xl">
        @if (viewCoupon?.uploaded_coupon_image) {
            <!-- Show uploaded coupon image only -->
            <div class="w-full flex flex-col gap-3">
                <img [src]="viewCoupon.uploaded_coupon_image" alt="Uploaded Coupon Image" (error)="onImageError($event)"
                    class="w-full rounded-lg object-cover" />
            </div>
        } @else if (viewCoupon) {
            <!-- Show coupon card with all details -->
            <div class="w-full p-1 rounded-lg" [ngClass]="getViewCouponGradientClass()" [ngStyle]="getViewCouponGradientStyle()">
                <div class="w-full aspect-[16/7] rounded-xl overflow-hidden relative">
                    <div class="w-full h-full grid grid-cols-5">
                        <div class="col-span-2 flex flex-col justify-center items-center h-full">
                            <div class="w-3/4 aspect-square bg-white/50 p-2 mask {{viewCoupon.image_shape || 'mask-squircle'}} relative overflow-hidden">
                                @if (viewCoupon.coupon_image) {
                                <img [src]="viewCoupon.coupon_image" alt="Coupon Image" (error)="onImageError($event)"
                                    class="absolute inset-0 w-full h-full object-cover" />
                                } @else {
                                <div class="flex h-full w-full items-center justify-center text-white/80">
                                    <i class="ri-image-fill text-4xl"></i>
                                </div>
                                }
                            </div>
                        </div>
                        <div class="col-span-3 p-4 leading-4 text-white flex flex-col justify-between">
                            <div>
                                <small class="text-sm text-center text-white/70">Benefits given by Teacher Factory</small>
                                <h2 class="text-4xl text-center font-bold mt-2">{{ viewCoupon.discount_amount }}{{ viewCoupon.discount_type === '$' ? '₹' : '%' }} OFF</h2>
                                <p class="text-xl text-center font-semibold mt-2">{{ viewCoupon.title || 'Title Here' }}</p>
                            </div>
                            <div class="mt-4">
                                <div class="border border-dashed border-white/100 rounded-lg px-4 py-3 text-center">

                                    <p class="text-lg font-bold tracking-[0.2em]">Code : {{ viewCoupon.code || 'CODE HERE' }}</p>
                                </div>
                                <div class=" mt-3 text-xs text-white/80">
                                    <div><span class="font-semibold">Valid:</span> {{ viewCoupon.from_date }} - {{ viewCoupon.to_date }}</div>
                                    <!-- <div><span class="font-semibold">Usage:</span> {{ viewCoupon.usage_per_user }}</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="text-center py-8">
                <p class="text-sm text-zinc-500">No coupon selected</p>
            </div>
        }
        <div class="modal-action">
            <button type="button" class="btn btn-sm" (click)="closeViewCouponModal()">Close</button>
        </div>
    </div>
</dialog>

<!-- view coupon image -->
